/* eslint-disable jsx-a11y/role-supports-aria-props */
import * as React from 'react';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import { useRecoilValue } from 'recoil';
import TableDatepicker from '../../TableDatepicker';
import { IDatepickerSettings, setTableDatepickerAtom } from '../../../store/recoil/TableState';
import usePrevious from '../../../hooks/usePrevious';

interface IComponentProps {
  action: any;
  label: any;
  columns: any;
  filterComponent: any;
  actionOpen: any;
  actionSave: any;
  menuNameOpen: any;
}

export default function DateRangePicker(props: IComponentProps) {
  const { formatMessage: f } = useIntl();
  const datepickerSettings = useRecoilValue<IDatepickerSettings | null>(setTableDatepickerAtom);

  const prevDatepickerSettings: any = usePrevious(
    datepickerSettings ? JSON.stringify(datepickerSettings) : ''
  );
  const prevColumnsName: any = usePrevious(
    props.columns.name ? JSON.stringify(props.columns.name) : ''
  );

  React.useEffect(() => {
    const { columns, filterComponent } = props;
    let prevDateTo = null;
    if (
      datepickerSettings &&
      datepickerSettings[columns.name] &&
      datepickerSettings[columns.name].date.length === 2 &&
      prevDatepickerSettings &&
      prevDatepickerSettings[prevColumnsName] &&
      prevDatepickerSettings[prevColumnsName].date
    ) {
      const dateFrom = datepickerSettings[columns.name].date[0];
      const dateTo = datepickerSettings[columns.name].date[1];
      const prevDateFrom = prevDatepickerSettings[prevColumnsName].date[0];
      if (prevDatepickerSettings[prevColumnsName].date.length === 2) {
        prevDateTo = prevDatepickerSettings[prevColumnsName].date[1];
      }
      if (
        JSON.stringify(prevDateFrom) !== JSON.stringify(dateFrom) ||
        dayjs(prevDateTo).format('DD.MM.YYYY HH:mm:ss:SSS') !==
          dayjs(dateTo).format('DD.MM.YYYY HH:mm:ss:SSS')
      ) {
        props.actionSave(
          columns.name,
          { min: dateFrom, max: dateTo },
          undefined,
          filterComponent.type,
          columns.title
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datepickerSettings]);

  const actionOpen = (e: any) => {
    props.actionOpen(e, props.columns.name);
  };

  const action = (e: any) => {
    props.action(props.columns.name, e);
  };

  const getDateFrom = () => {
    const dateFrom =
      !datepickerSettings ||
      !datepickerSettings[props.columns.name] ||
      !datepickerSettings[props.columns.name].date[0]
        ? ''
        : datepickerSettings[props.columns.name].date[0];
    return dateFrom ? dayjs(dateFrom).format('DD.MM.YYYY HH:mm') : '';
  };

  const getDateTo = () => {
    const dateTo =
      !datepickerSettings ||
      !datepickerSettings[props.columns.name] ||
      !datepickerSettings[props.columns.name].date[1]
        ? ''
        : datepickerSettings[props.columns.name].date[1];
    return dateTo ? dayjs(dateTo).format('DD.MM.YYYY HH:mm') : '';
  };

  return (
    <div
      data-cy={`datapicker-popup-${props.columns.name}`}
      className={`label ${
        props.label ? 'label-primary mb-xs position-relative label--filter' : ''
      } ${props.menuNameOpen[props.columns.name] === props.label ? 'open' : ''}`}
      style={{ padding: !props.label ? '0px' : '9px 8px 8px 8px' }}
      onClick={actionOpen}
    >
      {props.label && (
        <span>
          <TableDatepicker
            name={props.columns.name}
            isActive={props.columns.name === 'timestamp' || props.columns.filter.active}
            type="chip"
          >
            <a
              href="#"
              title={f({ id: 'table.filter.button' })}
              data-cy={`datapicker-filter-${props.columns.name}`}
              className="dropdown-toggle text-white text-decoration-none"
              id="dropdownMenu13"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
              onClick={actionOpen}
              style={{ paddingRight: props.columns.name !== 'timestamp' ? '30px' : '0' }}
            >
              {props.columns.title}: {getDateFrom()} - {getDateTo()}
            </a>
          </TableDatepicker>
          {props.columns.name !== 'timestamp' && (
            <div style={{ position: 'absolute', right: '10px', top: '7px' }}>
              <a
                href="#"
                title={f({ id: 'table.filter.remove' })}
                className="text-white"
                onClick={action}
                style={{ padding: '8px', margin: '-8px -8px -8px 0' }}
              >
                <i className="cmd-icon cmd-icon-remove-sm" />
              </a>
            </div>
          )}
        </span>
      )}
    </div>
  );
}
